import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import { submitLead } from "@/lib/api";

const CIUDADES = ["Monterrey", "Saltillo", "Torreón", "Chihuahua", "CDMX", "Guadalajara", "Mérida", "Cancún", "Otra"];

export default function HeroQuickForm({ sitio = "flexshade", producto = "flexshade", accentLabel = "Cotización rápida 24h", onSuccess, testId = "hero-quickform" }) {
    const navigate = useNavigate();
    const [submitting, setSubmitting] = useState(false);
    const [form, setForm] = useState({ nombre: "", telefono: "", ciudad: "" });

    const onSubmit = async (e) => {
        e.preventDefault();
        if (form.nombre.trim().length < 2) return toast.error("Ingresa tu nombre");
        if (form.telefono.replace(/\D/g, "").length < 10) return toast.error("Teléfono inválido (10 dígitos)");
        if (!form.ciudad) return toast.error("Selecciona ciudad");
        setSubmitting(true);
        try {
            await submitLead({ ...form, sitio, producto, fuente: "hero_quickform" });
            toast.success("¡Listo! Te contactamos hoy mismo.");
            setForm({ nombre: "", telefono: "", ciudad: "" });
            onSuccess?.();
            navigate(`/gracias?sitio=${sitio}`);
        } catch (err) {
            toast.error("Hubo un problema. Intenta de nuevo o escríbenos al WhatsApp.");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <aside
            data-testid={testId}
            className="hidden lg:block bg-white border border-neutral-200 rounded-sm shadow-2xl p-6 w-[340px]"
        >
            <div className="mb-4 pb-3 border-b border-neutral-200">
                <p className="text-[10px] font-display font-bold tracking-[0.25em] text-eclipse-cta uppercase mb-1">{accentLabel}</p>
                <h3 className="font-display font-black text-xl text-eclipse-primary leading-tight">Cotiza en 30 segundos</h3>
                <p className="text-xs text-eclipse-muted mt-1">Ingenieros responden en menos de 24h.</p>
            </div>
            <form onSubmit={onSubmit} className="space-y-3">
                <input
                    type="text"
                    placeholder="Tu nombre completo"
                    value={form.nombre}
                    onChange={(e) => setForm({ ...form, nombre: e.target.value })}
                    data-testid={`${testId}-nombre`}
                    className="w-full px-3 py-2.5 border border-neutral-300 rounded-sm text-sm focus:outline-none focus:border-eclipse-cta focus:ring-1 focus:ring-eclipse-cta"
                    required
                />
                <input
                    type="tel"
                    placeholder="Teléfono / WhatsApp"
                    value={form.telefono}
                    onChange={(e) => setForm({ ...form, telefono: e.target.value })}
                    data-testid={`${testId}-telefono`}
                    className="w-full px-3 py-2.5 border border-neutral-300 rounded-sm text-sm focus:outline-none focus:border-eclipse-cta focus:ring-1 focus:ring-eclipse-cta"
                    required
                />
                <select
                    value={form.ciudad}
                    onChange={(e) => setForm({ ...form, ciudad: e.target.value })}
                    data-testid={`${testId}-ciudad`}
                    className="w-full px-3 py-2.5 border border-neutral-300 rounded-sm text-sm focus:outline-none focus:border-eclipse-cta bg-white"
                    required
                >
                    <option value="">Selecciona tu ciudad...</option>
                    {CIUDADES.map((c) => <option key={c} value={c}>{c}</option>)}
                </select>
                <button
                    type="submit"
                    disabled={submitting}
                    data-testid={`${testId}-submit`}
                    className="btn-eclipse-cta w-full py-3 rounded-sm text-xs uppercase tracking-wider inline-flex items-center justify-center gap-2"
                >
                    {submitting ? "Enviando..." : "Quiero mi cotización"}
                    <ArrowRight className="w-4 h-4" />
                </button>
                <p className="text-[10px] text-eclipse-muted text-center leading-snug">Sin compromiso. Tus datos no se comparten.</p>
            </form>
        </aside>
    );
}
